import React from "react";
import Toggle from "react-toggle";
import './optionsPanel.css';
import Options from "../../options/Options";
import Params from "../../options/Params";

interface OptionsState {
    hidden: boolean;
    showOrbitalBar: boolean;
    showAtomCounter: boolean;
    showHybridizeButton: boolean;
}

export default class OptionsPanel extends React.Component<{}, OptionsState> {

    constructor(props: Readonly<{}>) {
        super(props);

        const loadedOptions = Options.parseAuthorParams(Params.authorOptions);

        this.state = {
            hidden: Params.raw.showOptions == "false",
            ...loadedOptions
        };
    }

    componentDidUpdate() {
        Options.setAuthoredOptions(this.state);
    }

    render() {
        if (this.state.hidden) {
            return "";
        }

        return <div className="options-panel">
            <div className="options-panel-option">
                <Toggle defaultChecked={this.state.showOrbitalBar} onChange={(e) => this.setState({ showOrbitalBar: e.target.checked })} />
                Show Orbital Bar
            </div>
            <div className="options-panel-option">
                <Toggle defaultChecked={this.state.showAtomCounter} onChange={(e) => this.setState({ showAtomCounter: e.target.checked })} />
                Show Atom Counter
            </div>
            <div className="options-panel-option">
                <Toggle defaultChecked={this.state.showHybridizeButton} onChange={(e) => this.setState({ showHybridizeButton: e.target.checked })} />
                Show Hybridize Button
            </div>
        </div>
    }
}
